import React, { ReactElement, ReactNode, useState } from 'react';
import CaretRightIcon from 'assets/icons/caretRight.svg?react';
import styles from './AGCollapsibleTable.module.css';

type GroupedCollapsibleRowsProps = {
    children: ReactNode;
    parentRowContent: ReactElement;
    parentRowText: string;
};

const GroupedCollapsibleRows = ({ children, parentRowContent, parentRowText }: GroupedCollapsibleRowsProps) => {
    const [collapsed, toggleCollapsed] = useState(true);

    return (
        <>
            <tr onClick={() => toggleCollapsed(!collapsed)} className={styles.clickableRow}>
                <td>
                    {parentRowText}
                    <CaretRightIcon className={`${styles.caret} ${!collapsed && styles.expanded}`} />
                </td>
                {parentRowContent}
            </tr>
            {!collapsed && children}
        </>
    );
};

export default GroupedCollapsibleRows;
